import {exportRequest, postRequest} from '@/libs/axios';

// 内部订单分页查询
export const innerOrderPage = (params) => {
    return postRequest('/ndt/innerOrder/page', params)
}

// 内部订单详情
export const innerOrderDetail = (params) => {
    return postRequest('/ndt/innerOrder/detail', params)
}

// 内部订单物品列表
export const innerOrderGoodsList = (params) => {
    return postRequest('/ndt/innerOrder/goodsList', params)
}

// 导出内部订单
export const exportInnerOrder = (params) => {
    return exportRequest('/ndt/innerOrder/export', params)
}
